import React, { useState, useEffect } from "react";
import styled from "styled-components";
import SideMenu from "../SideMenu";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import Card from "./Card";
import Footer from "../../Common/Footer";
import Nav from "../../Common/Nav";
import RequireLogin from "../../../permissions.js/RequireLogin";
import Cookies from "js-cookie";
import PageLoader from "../../Common/PageLoader";

function Overview() {
  const [allPolicies, setAllPolicies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [accounts, setAccount] = useState([]);
  const [documents, setDocumnets] = useState([]);

  useEffect(() => {
    const userid = Cookies.get("hippocratic_portal_contactid");
    setIsLoading(true);

    Promise.allSettled([
      getApiClient().getAllInforcePolicies(userid),
      getApiClient().getActiveWMAccountsUOM(userid),
      getApiClient().getFolders({
        location: "/8. Upload for Review by Member",
      }),
    ])
      .then((results) => {
        // Handle each result independently
        results.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            switch (index) {
              case 0:
                setAllPolicies(result.value.data);
                break;
              case 1:
                setAccount(result.value.data);
                break;
              case 2:
                setDocumnets(result.value.data.children);
                break;
            }
          } else {
            console.error(`API call ${index} failed:`, result.reason);
          }
        });
      })
      .catch((error) => {
        console.error('Error in promise handling:', error);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <TopSection>
          <NavigationInformation>
            Home &gt; My Profile &gt; Overview
          </NavigationInformation>
          <Title>Overview</Title>
        </TopSection>
        <BottomSection>
          <SideMenu />
          <RightContainer>
            {allPolicies && (
              <Card
                type="Policies"
                allPolicies={allPolicies}
                BackgroundColor={"#de923a"}
                Title={"Your Policies"}
              />
            )}
            {accounts && (
              <Card
                type="WM"
                accounts={accounts}
                BackgroundColor={"#61b8bf"}
                Title={"Your WM Accounts"}
              />
            )}
            {documents && (
              <Card
                type="documents"
                documents={documents}
                BackgroundColor={"#94caf1"}
                Title={"Files Needs Review"}
              />
            )}
          </RightContainer>
        </BottomSection>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  gap: 50px;
  width: 100vw;
  padding: 0px 5vw;
  overflow-x: clip !important;
`;

const TopSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
`;

const NavigationInformation = styled.div`
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

const Title = styled.div`
  color: var(--darkBlue);
  font-family: Georgia;
  font-size: 55px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: -1.1px;

  @media screen and (max-width: 719px) {
    font-size: 40px;
  }
`;

const BottomSection = styled.div`
  display: flex;
  gap: 30px;
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

export default RequireLogin(Overview);
